import Autocomplete from "@mui/material/Autocomplete";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { PipelineConfig } from "../../../interfaces/doc";
import { filterClassificationQueries } from "./ResultFormUtils";

const ClassificationForm: React.FC<{ config: PipelineConfig }> = ({
  config,
}) => {
  const { control } = useFormContext();
  const split = useWatch({ name: "classification.split" });

  return (
    <>
      <Typography fontWeight="bold" gutterBottom>
        Classifications
      </Typography>
      {!!config.split && (
        <Controller
          render={({ field: { onChange, ...props } }) => (
            <Autocomplete
              disablePortal
              size="small"
              options={[
                ...config.split!.segmentation.classes.map(
                  (classe) => classe.name
                ),
                ...(config.split!.segmentation.default
                  ? [config.split!.segmentation.default.name]
                  : []),
              ]}
              renderInput={(params) => (
                <TextField {...params} label="Découpage" />
              )}
              onChange={(e, lang) => onChange(lang)}
              {...props}
            />
          )}
          name={`classification.split`}
          control={control}
        />
      )}
      {!!config.classification &&
        filterClassificationQueries(config.classification.queries, split).map(
          (query) => (
            <Controller
              key={query.name}
              render={({ field: { onChange, ...props } }) => (
                <Autocomplete
                  disablePortal
                  size="small"
                  options={[
                    ...query.classes.map((classe) => classe.name),
                    ...(query.default ? [query.default.name] : []),
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} label={query.name} />
                  )}
                  onChange={(e, lang) => onChange(lang)}
                  {...props}
                />
              )}
              name={`classification.${query.name}`}
              control={control}
            />
          )
        )}
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default ClassificationForm;
